import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import CustomForLoanModuleButtonTabs from "../../Components/ButtonTabs/CustomForLoanModuleButtonTabs";
import { APICall } from "../../Helpers/Network/APICalls";
import { useLocation } from "react-router-dom";
import { SettlementDetailsById } from "../../Helpers/APIEndPoints/EndPoints";
import { useDispatch } from "react-redux";
import { setIsLoanParams } from "../../Redux/Actions/LoanModuleAction";
import { Typography } from "@mui/material";
import StlmtPersonalDetails from "./StlmtPersonalDetails";
import StlmtLoanDetails from "./StlmtLoanDetails";
import FinalSettlementGrid from "./FinalSettlementGrid";
import SettlementStatus, { SettlementModule } from "./SettlementStatus";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";

const CustomTabPanel = (props: any) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      aria-disabled={false}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const SettlmentRequestTabs = () => {
  const context = getContext();
  const [value, setValue] = useState(-1);
  const [RejectedRemarks, setRejectedRemarks] = useState("");
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const StateCurrentStatus = state?.currentStatus;
  const StateSetId = state?.SetId;
  const StateMemberId = state?.MemberId;
  const StateMode = state?.mode;

  useEffect(() => {
    getLoanDetails();
    getPersonalDetailsByIdApiCalllls();
  }, []);

  const getLoanDetails = async () => {
    showLoader();
    dispatch(
      setIsLoanParams({ LoanId: state?.Id, MemberId: context.MemberId })
    );
    setValue(0);
    hideLoader();
  };
  const [statusComponents, setStatusComponents] = useState<any>([]);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // setTabsStatus((prevStatus) => prevStatus.map((_, index) => index <= newValue));
  };

  const getPersonalDetailsByIdApiCalllls = async () => {
    showLoader();
    // let requestParams = { MemberId: MemberId };

    const res = await APICall(SettlementDetailsById, {
      SetId: StateSetId,
      MemberId: StateMemberId,
    });
    
    if (res?.Data != null) {
      setRejectedRemarks(res?.Data?.[0]?.Comment);

      let statusComponents = [
        {
          isVisible: true,
          label: "Personal Details",
          value: { ...a11yProps(0) },
          component: (
            <StlmtPersonalDetails
              statecurrentstatus={StateCurrentStatus}
              statesetid={StateSetId}
              statememberid={StateMemberId}
              mode={state?.mode}
              selectNextTab={() => 1}
              selectPreviousTab={(index) => 1}
            />
          ),
        },

        {
          label: "Loan Detail",
          value: { ...a11yProps(1) },
          // isVisible:
          //   [
          //     LoanStatus.LoanModule_PendingWithInternalTeam,
          //     LoanStatus.LoanModule_PendingMemberLoanConfirmation,
          //   ].includes(res?.Data?.Lrd_StatusId) &&
          //   context?.CurrentRoleId === RoleEnum.InternalTeam,
          isVisible: true,
          component: (
            <StlmtLoanDetails
              statecurrentstatus={StateCurrentStatus}
              statesetid={StateSetId}
              statememberid={StateMemberId}
              mode={state?.mode}
              selectNextTab={() => 1}
              selectPreviousTab={(index) => 1}
            />
          ),
        },
        {
          label: "Final Settlement",
          value: { ...a11yProps(1) },
          isVisible: true,
          component: (
            <FinalSettlementGrid
              statecurrentstatus={StateCurrentStatus}
              statesetid={StateSetId}
              statememberid={StateMemberId}
              mode={state?.mode}
              selectNextTab={() => 1}
              selectPreviousTab={(index) => 1}
            />
          ),
        },
      ];
      hideLoader();
      setStatusComponents(
        statusComponents.filter((status) => status.isVisible)
      );
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      {context.CurrentRoleId === RoleEnum.Member && (
        <SettlementStatus
          statusId={StateCurrentStatus}
          SettlementNameModule={SettlementModule.SettlementDetails}
          rejectReasons={RejectedRemarks}
        />
      )}
      <CustomForLoanModuleButtonTabs
        value={value}
        handleChange={handleChange}
        tabs={statusComponents.filter((status) => status.isVisible)}
      />
      {statusComponents.length > 0 &&
        statusComponents.map((status, index) => {
          return (
            <React.Fragment key={index}>
              {status.isVisible && (
                <CustomTabPanel value={value} index={index}>
                  {status.component}
                </CustomTabPanel>
              )}
            </React.Fragment>
          );
        })}
    </Box>
  );
};

export default SettlmentRequestTabs;

//Personal details
//Loan details
